"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAllowedLayers = exports.SET_ALLOWED_LAYERS_SUCCESS = void 0;
var SET_ALLOWED_LAYERS_SUCCESS = 'SET_ALLOWED_LAYERS_SUCCESS';
exports.SET_ALLOWED_LAYERS_SUCCESS = SET_ALLOWED_LAYERS_SUCCESS;

var setAllowedLayers = function setAllowedLayers(allowedLayers, visibilityConfig, userType) {
  return function (dispatch) {
    dispatch({
      type: SET_ALLOWED_LAYERS_SUCCESS,
      allowedLayers: allowedLayers,
      visibilityConfig: visibilityConfig,
      userType: userType
    });
  };
};

exports.setAllowedLayers = setAllowedLayers;